import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';

function createSupabaseDriver(client,opts){
  opts=opts||{};
  const table=opts.table||'research_states';
  if(!client) throw new Error('SUPABASE_CLIENT_REQUIRED');

  function ensureResult(res){
    if(res && res.error) throw new Error(res.error.message||'SUPABASE_ERROR');
    return res;
  }

  return Object.freeze({
    kind:'SUPABASE_CONTRACT',

    async get(key){
      const q=client.from(table).select('storage_key,payload').eq('storage_key',key).maybeSingle();
      const res=ensureResult(await q);
      return res && res.data ? res.data.payload : null;
    },

    async set(key,value){
      const row={
        storage_key:key,
        symbol:value&&value.symbol||null,
        scope:value&&value.scope||null,
        schema_version:value&&value.schemaVersion||null,
        saved_at:value&&value.savedAt||null,
        payload:value
      };
      const q=client.from(table).upsert(row,{onConflict:'storage_key'});
      ensureResult(await q);
      return true;
    },

    async remove(key){
      const q=client.from(table).delete().eq('storage_key',key).select('storage_key');
      const res=ensureResult(await q);
      return !!(res && Array.isArray(res.data) && res.data.length);
    },

    async keys(){
      const q=client.from(table).select('storage_key').order('storage_key',{ascending:true});
      const res=ensureResult(await q);
      return Array.isArray(res&&res.data)?res.data.map(x=>x.storage_key).filter(Boolean):[];
    }
  });
}

function schemaSQL(table){
  const safe=/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(table||'')?table:'research_states';
  return [
    `create table if not exists public.${safe} (`,
    `  storage_key text primary key,`,
    `  symbol text not null,`,
    `  scope text not null,`,
    `  schema_version text not null,`,
    `  saved_at timestamptz not null,`,
    `  payload jsonb not null,`,
    `  updated_at timestamptz not null default now()`,
    `);`,
    ``,
    `create index if not exists ${safe}_symbol_scope_idx`,
    `  on public.${safe}(symbol, scope);`
  ].join('\n');
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});

  const calls=[];
  function builder(op){
    const obj={
      select(...a){calls.push([op,'select',...a]); return obj;},
      eq(...a){calls.push([op,'eq',...a]); return obj;},
      maybeSingle(){calls.push([op,'maybeSingle']); return Promise.resolve({data:{payload:{x:1}},error:null});},
      upsert(...a){calls.push([op,'upsert',...a]); return Promise.resolve({data:null,error:null});},
      delete(){calls.push([op,'delete']); return obj;},
      order(...a){calls.push([op,'order',...a]); return Promise.resolve({data:[{storage_key:'a'},{storage_key:'b'}],error:null});},
      then(resolve){ return Promise.resolve({data:[{storage_key:'a'}],error:null}).then(resolve); }
    };
    return obj;
  }
  const client={from(table){calls.push(['from',table]); return builder(table);}};

  const d=createSupabaseDriver(client,{table:'research_states'});
  ok('driver kind is contract',d.kind==='SUPABASE_CONTRACT');

  const sql=schemaSQL('research_states');
  ok('schema contains primary key',sql.includes('storage_key text primary key'));
  ok('schema contains jsonb payload',sql.includes('payload jsonb not null'));
  ok('schema contains symbol/scope index',sql.includes('symbol_scope_idx'));
  ok('unsafe table name falls back',schemaSQL('bad-name').includes('public.research_states'));

  return Promise.resolve()
    .then(()=>d.get('k1'))
    .then(v=>ok('get returns payload',v&&v.x===1))
    .then(()=>d.set('k1',{symbol:'AAA',scope:'OWNED',schemaVersion:'1',savedAt:'2026-08-30T12:00:00Z'}))
    .then(v=>ok('set resolves true',v===true))
    .then(()=>d.keys())
    .then(v=>ok('keys returns ordered keys',Array.isArray(v)&&v.length===2&&v[0]==='a'))
    .then(()=>{
      ok('table access recorded',calls.some(x=>x[0]==='from'&&x[1]==='research_states'));
      ok('upsert used for save',calls.some(x=>x[1]==='upsert'));
      ok('maybeSingle used for get',calls.some(x=>x[1]==='maybeSingle'));
      ok('no trade signal on driver',!('tradeSignal' in d));
      ok('no capital permission on driver',!('capitalPermission' in d));
      return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
    });
}

const API={VERSION,createSupabaseDriver,schemaSQL,selfTest};
global.ZooInvestSupabaseRepositoryDriverContract=Object.freeze(API);
})(engineContext);